import { Component, OnInit, ViewChild } from "@angular/core";
import { AccountService } from "app/_services/account.service";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialogRef, MatDialog } from "@angular/material";
import { SubmitSuccessComponent } from "../submit-success/submit-success.component";
import { SweetAlertService } from "ng2-sweetalert2";
import { AppState } from "@_services";
import { LanguageService } from "@_services/language.service";
import { FileuploadComponent } from "../fileupload/fileupload.component";
import { Observable } from "rxjs";
@Component({
  selector: "app-mvbweb",
  templateUrl: "./mvbweb.component.html",
  styleUrls: ["./mvbweb.component.scss"],
  providers: [SweetAlertService],
})
export class MvbwebComponent implements OnInit {
  @ViewChild("fileupload") file: FileuploadComponent;
  MVB: FormGroup;
  loading = false;
  currentLang: Observable<string>;
  constructor(
    public accountService: AccountService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<MvbwebComponent>,
    public dialog: MatDialog,
    private appState: AppState,
    public languageService: LanguageService,
    private swalService: SweetAlertService
  ) {}

  ngOnInit() {
    this.MVB = this.fb.group({
      title: new FormControl("", [Validators.required]),
      browser: new FormControl("", [Validators.required]),
      Title: new FormControl("", [Validators.required]),
      FileGroup: this.fb.group({
        Description: new FormControl("", [Validators.required]),
        FlagCtrl: new FormControl(false),
      }),
    });
    this.currentLang = this.languageService.loadCurrentLang();
  }

  errorPop() {
    this.swalService.swal({
      title: "Error",
      text: "Something went wrong, please try again",
      type: "error",
      buttonsStyling: false,
      showCancelButton: false,
      allowOutsideClick: false,
      confirmButtonClass: "btn btn-primary  mr-4",
      confirmButtonText: "Confirm",
    });
  }

  sendTicket() {
    this.file.isClicked = true;
    if (!this.MVB.valid) return false;
    this.loading = true;
    const text = this.file.FileGroup.controls["Description"].value;
    const ticket_title = this.MVB.controls["browser"].value;
    const problem = this.MVB.controls["Title"].value;
    const ticket = {
      product: "mvb-0001",
      category: ticket_title,
      title: problem,
      description: text,
      screenshots: this.file.keylist,
    };
    // console.log('send ticket', ticket)
    this.accountService.d365SendCase(ticket).subscribe(
      () => {
        if (this.appState._state["ticket-cases"])
          delete this.appState._state["ticket-cases"];
        this.loading = false;
        this.dialogRef.close();
        this.dialog.open(SubmitSuccessComponent, {
          width: "400px",
          minWidth: "310px",
          height: "auto",
        });
      },
      () => {
        this.loading = false;
        this.errorPop();
      }
    );
  }
}
